import { render, staticRenderFns } from "./ActionPostponeRoaming.vue?vue&type=template&id=881bf0fc"
import script from "./ActionPostponeRoaming.vue?vue&type=script&lang=js"
export * from "./ActionPostponeRoaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports